import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'property-card',
  standalone: false,
  templateUrl: './property-card.component.html',
  styleUrl: './property-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PropertyCardComponent {

}
